import router from "./index";

export default [
  {
    path: "/VenueManage",
    component: () => import('../views/VenueManage/VenueManage'),
    beforeEnter: (to, from, next) => {
      if (router.app.$cookies.get("user") != "student")
        next();
      else
        router.replace("/home");
    },
    meta: {
      title: '场馆管理'
    },
    children: [
      {
        path: '/',
        redirect: 'VenueMList'
      },
      {
        path: 'VenueMList',
        component: () => import('../views/VenueManage/VenueMList/VenueMList'),
        meta: {
          title: '场馆列表'
        },
      },
      {
        path: 'AddVenue',
        component: () => import('../views/VenueManage/AddVenue/AddVenue'),
        meta: {
          title: '添加场馆'
        },
      }, {
        path: 'ViewStudent',
        component: () => import('../views/VenueManage/ViewStudent/ViewStudent'),
        meta: {
          title: '预约学生列表'
        },
      },
      {
        path: 'VenueQrCode',
        component: () => import('../views/VenueManage/VenueQrCode/VenueQrCode'),
        meta: {
          title: '场馆二维码'
        },
      },
    ]
  },
]
